import { Component, Input, OnInit,OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner'; // For p-progressSpinner if you add it
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService, ConfirmationService } from 'primeng/api'; // Import services for messages and confirmations
import { Relation } from '../../../../models/user.model';
import { TranslateService } from '../../../../services/translate.service';
import { MaintainAccountService } from '../maintain-account.service';
import { DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { RelationsComponent } from '../../create-account/steps/relations/relations.component';

import { Pagination } from '../../../../services/pagination.abstruct';

@Component({
  selector: 'app-tab-relations',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    TagModule,
    ButtonModule,
    ProgressSpinnerModule,
    TooltipModule,
    FormsModule
  ],
  templateUrl: './tab-relations.component.html',
  styleUrls: ['./tab-relations.component.scss'],
  providers: [DialogService, MessageService]
  
})
export class TabRelationsComponent extends Pagination implements OnInit, OnDestroy{
  @Input() relations!: any[];
  @Input() selectedEntityType: 'Customer' | 'Supplier' = 'Customer'; // or 'Supplier'
  @Input() relationsLoading!: boolean;
  @Input() relationsError!: boolean;

  @Input() customerRecId!: number;

  @ViewChild('dt') dt!: Table;
  
  ref: DynamicDialogRef| undefined;
  private destroy$ = new Subject<void>();



  globalFilter: string = '';
  globalFilterFields: string[] = [];

  constructor(public translateServ :TranslateService,
              private messageService: MessageService,
              private confirmationService: ConfirmationService,
              private maintainAccountService: MaintainAccountService,
              private dialogService: DialogService) 
  { super();}

  ngOnInit(): void 
  {
    if (this.relations?.length > 0) 
    {
      this.globalFilterFields = Object.keys(this.relations[0]);
    }
  }

  ngOnDestroy(): void 
  {
    if (this.ref) {
      this.ref.close();
    }
  }

  private getRelationDisplay(relation: any): string { // Use 'any' or extend Relation interface to match HTML
    if (relation.CustomerName) {
      return `${relation.CustomerName} (${relation.RelationType})`;
    }
    return `${relation.RelatedPartyId} (${relation.RelationType})`;
  }

  editRelation(relation: Relation): void { // Use 'any' or extend Relation interface to match HTML
    this.ref = this.dialogService.open(RelationsComponent, {
          header: this.translateServ.dictionary['STEPPER_DIALOG_TITLE_EDIT'] || 'Edit Record',
          width: '70%',
          contentStyle: { overflow: 'auto' },
          baseZIndex: 10000,
          maximizable: true,
          data: {
            isDialog: true,
            isCreate: false,
            entityType: this.selectedEntityType,
            customerRecId: this.customerRecId,
            nameEntry: {
              id: relation.RecID.toString(),
              UserRecID: relation.RecID,
              connectedEntityId: relation.SupplierRecID,
              customer_supplier_number: relation.customer_supplier_num,
              innerNumber: relation.customer_id,
              description: relation.Descr,
              isActive: relation.IsActive,
              isApproved: relation.IsApproved,
              partnerRecId: relation.SupplierRecID
            }
          }
        });
    
        this.ref.onClose.pipe(takeUntil(this.destroy$)).subscribe((result) => {
          if (result) {
            this.messageService.add({
              severity: 'success',
              summary: this.translateServ.dictionary['SUCCESS'] || 'Success',
              detail: this.translateServ.dictionary['MAINT_UPDATE_SUCCESS_MSG'] || 'Record updated successfully.',
              life: 3000
            });
            this.reloadRelationForUser();
          }
        });
      }


  updateRelStatus(source : boolean,recId: number, newStatus: 0 | 1): void {
    // Calling the API service to update the status
    this.maintainAccountService.updateFunctions(source, this.constructor.name.substring(1), recId, newStatus).subscribe({
      next: (response: any) => {
        // Check if the API response indicates a successful update
        if (response && response[0]?.RecID && response[0].RecID !== -1) {
          const index = this.relations?.findIndex(name => name.RecID === recId);
          if (this.relations && index !== undefined && index > -1) {
            // Correctly updating the 'IsActive' or 'IsApproved' property
            if(source)
			{
				this.relations[index].IsActive = newStatus;	
			}
			else
			{
				this.relations[index].IsApproved = newStatus;	
			}
            
            const statusText = newStatus === 1 ? 'Active' : 'Inactive';
            this.messageService.add({
              severity: 'success',
              summary: this.translateServ.dictionary['STATUS_UPDATED'] || 'Status Updated',
              // Correctly using the 'Street' property for the message
              detail: `Relation "${this.relations[index].Phone}" is now ${statusText}.`,
              life: 3000
            });
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.translateServ.dictionary['ERROR'] || 'Error',
            detail: this.translateServ.dictionary['STATUS_UPDATE_FAILED'] || 'Failed to update status. Record not found or invalid response.',
            life: 5000
          });
        }
      },
      error: (err: any) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: this.translateServ.dictionary['ERROR'] || 'Error',
          detail: this.translateServ.dictionary['STATUS_UPDATE_FAILED'] || 'Failed to update status. Please try again.',
          life: 5000
        });
      }
    });
  }


	// Confirms and deletes a record
	confirmDelete(relation: any): void {
		this.confirmationService.confirm({
		message: `${this.translateServ.dictionary['MAINT_DELETE_CONFIRM_MSG'] || 'Are you sure you want to delete this record?'} (ID: ${relation.RecID})`,
		header: this.translateServ.dictionary['MAINT_DELETE_CONFIRM_HEADER'] || 'Confirm Deletion',
		icon: 'pi pi-exclamation-triangle',
		acceptLabel: this.translateServ.dictionary['CONFIRM_DELETE'] || 'Delete',
		rejectLabel: this.translateServ.dictionary['CONFIRM_CANCEL'] || 'Cancel',	
		accept: () => {
			this.maintainAccountService.deleteRecord(this.constructor.name.substring(1) , relation.RecID)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (response) => {
				this.messageService.add({
					severity: 'success',
					summary: this.translateServ.dictionary['SUCCESS'] || 'Success',
					detail: this.translateServ.dictionary['MAINT_DELETE_SUCCESS_MSG'] || 'Record deleted successfully.',
					life: 3000,
				});
				this.reloadRelationForUser();
				},
				error: (error) => {
				console.error('Failed to delete record:', error);
				this.messageService.add({
					severity: 'error',
					summary: this.translateServ.dictionary['ERROR'] || 'Error',
					detail: this.translateServ.dictionary['MAINT_DELETE_FAILED_MSG'] || 'Failed to delete record.',
					life: 5000,
				});
				}
			});
		},
		reject: () => {
			// The user clicked "Cancel", so we can just close the dialog.
		}
		});
	}

  toggleRelationStatus(relation: Relation, action : boolean ): void { // Use 'any' or extend Relation interface to match HTML
    const newStatus = action ? (relation.IsActive === 1 ? 0 : 1) : (relation.IsApproved === 1 ? 0 : 1);
    const actionText = newStatus === 1 ?
      (this.translateServ.dictionary['ACTIVATE'] || 'activate') :
      (this.translateServ.dictionary['DEACTIVATE'] || 'deactivate');

    this.confirmationService.confirm({
      message: `${this.translateServ.dictionary['CONFIRM_CHANGE_STATUS'] || 'Are you sure you want to'} ${actionText} ${relation.RelatedPartyId}?`,
      header: this.translateServ.dictionary['CONFIRM_ACTION'] || 'Confirm Action',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translateServ.dictionary['YES'] || 'Yes',
      rejectLabel: this.translateServ.dictionary['NO'] || 'No',
      accept: () => {
        this.updateRelStatus(action, relation.RecID, newStatus);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: this.translateServ.dictionary['CANCELLED'] || 'Cancelled',
          detail: this.translateServ.dictionary['ACTION_CANCELLED'] || 'Action cancelled.',
          life: 3000
        });
      }
    });
  }

  getRelationSeverity(isActive: number): string {
    return isActive === 1 ? 'success' : 'danger';
  }

  createNewRecord(): void 
  {
    // FIX: Pass the customerRecId to the AdditionalNamesComponent via the data property
        this.ref = this.dialogService.open(RelationsComponent, 
        {
          header: this.translateServ.dictionary['STEPPER_DIALOG_TITLE'] || 'Create New Record',
          width: '70%',
          contentStyle: { overflow: 'auto' },
          baseZIndex: 10000,
          maximizable: true,
          data: {
            isDialog: true,
            isCreate: true,
            entityType: this.selectedEntityType,
            customerRecId: this.customerRecId // Pass the ID here
          }
        });
    
        // Subscribe to the dialog's onClose event
        this.ref.onClose.pipe(takeUntil(this.destroy$)).subscribe((result) => {
          // Check if the dialog was closed with a successful action (e.g., a "save" button click)
          // The AdditionalNamesComponent would need to return a value like 'true' upon success
          // to trigger this.
          if (result) {
            this.messageService.add({
              severity: 'success',
              summary: this.translateServ.dictionary['SUCCESS'] || 'Success',
              detail: this.translateServ.dictionary['MAINT_CREATE_SUCCESS_MSG'] || 'Record created successfully.',
              life: 3000
            });
            this.reloadRelationForUser();
          }
        });
    }

  applyGlobalFilter(): void 
  {
    this.dt.filterGlobal(this.globalFilter, 'contains');
  }

  private reloadRelationForUser(): void {
    // Call the service method to get the updated data
    const index =  this.maintainAccountService.getMappingIndex("relations");
    const instance = this.maintainAccountService.getUserDataMappings();
    this.maintainAccountService.getDatas(this.customerRecId, instance[index].apiName, instance[index].special)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          // Map Supplier_Name to CustomerName for table display
          this.relations = Array.isArray(data)
            ? data.map(item => {
                const obj = item as any;
                return {
                  ...obj,
                  CustomerName: obj.CustomerName || obj.Supplier_Name || ''
                };
              })
            : [];
          this.relationsLoading = false;
        },
        error: (error) => {
          console.error('Failed to reload relations:', error);
          this.relationsError = true;
          this.relationsLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateServ.dictionary['ERROR'] || 'Error',
            detail: this.translateServ.dictionary['MAINT_LOAD_FAILED_MSG_REL'] || 'Failed to load relations.',
            life: 5000
          });
        }
      });
  }
}